import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactEmail } from "@/lib/types";
import { baseContactRoute } from "./contact";

export function createContactEmailV1(
  data: Pick<ContactEmail, "address" | "label" | "contactId"> &
    Partial<ContactEmail>,
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactEmail>>(`${baseContactRoute}/emails`, data)
    .then((res) => res.data);
}

export function updateContactEmailV1(
  data: Pick<ContactEmail, "address" | "contactId" | "id" | "dateModified"> &
    Partial<ContactEmail>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<ContactEmail>>(`${baseContactRoute}/emails`, data)
    .then((res) => res.data);
}

export function deleteContactEmailV1({
  id,
}: {
  contactId: string;
  id: string;
}) {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactEmail>>(`${baseContactRoute}/emails/${id}`)
    .then((res) => res.data);
}
